import { useState, useContext } from "react";
import { Checkbox, FormControlLabel, Button } from "@mui/material";

import { useHistory } from "react-router";

import { DateTime } from "luxon";

import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";

import PJPContext from "pages/PJPView/pjp.context";

import { updatePlans } from "_controllers/officer";

const PJPActionDialog = ({
  open,
  status,
  selectedDates,
  setSelectedDates,
  planDate,
  matchingDates,
  handleAction,
  handleClose,
}) => {
  console.log(selectedDates);

  return (
    <Dialog open={open}>
      <DialogTitle>
        {status === "approve"
          ? "Would you like to approve any other matching dates?"
          : ""}
        {status === "edit"
          ? "Would you like to send any other matching dates for edit?"
          : ""}
      </DialogTitle>
      {matchingDates?.length > 0 && (
        <DialogContent>
          <FormControlLabel
            label={`${planDate.day}/${planDate.month}/${planDate.year}`}
            control={
              <Checkbox checked={true} onChange={() => {}} disabled={true} />
            }
          />
          {matchingDates?.map((date) => {
            return (
              <div>
                <FormControlLabel
                  label={DateTime.fromISO(date).toFormat("dd/MM/yyyy")}
                  control={
                    <Checkbox
                      checked={selectedDates.includes(date)}
                      onChange={(event) => {
                        if (event.target.checked)
                          setSelectedDates([...selectedDates, date]);
                        else
                          setSelectedDates(
                            selectedDates.filter((sDate) => sDate !== date)
                          );
                      }}
                    />
                  }
                />
              </div>
            );
          })}
        </DialogContent>
      )}
      <DialogActions>
        <Button variant="outlined" onClick={handleAction}>
          Confirm
        </Button>
        <Button
          variant="outlined"
          sx={{ color: "red", borderColor: "red" }}
          onClick={handleClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const PJPAction = () => {
  const history = useHistory();

  const { officer, plan, planDate } = useContext(PJPContext);

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);

  const handleAction = async () => {
    const planDateParsed = DateTime.fromFormat(
      `${planDate.year}-${planDate.month}-${planDate.day}`,
      "yyyy-MM-d"
    );

    let updateStatus;

    if (status === "approve") updateStatus = "Approved";
    if (status === "edit") updateStatus = "Reverted";
    if (status === "reject") updateStatus = "Rejected";

    const dates = [
      ...selectedDates.map((date) => DateTime.fromISO(date)),
      planDateParsed,
    ];

    const plans = dates.map((date) => ({
      planDate: date.toFormat("yyyy-MM-dd"),
      status: updateStatus,
    }));

    const updatedPlans = await updatePlans({ SAP_ID: officer.SAP_ID, plans });

    setOpen(false);

    history.go(0);
  };

  const handleClose = () => {
    setStatus("");
    setSelectedDates([]);
    setOpen(false);
  };

  return (
    <div className="pjp-action-buttons">
      <PJPActionDialog
        open={open}
        status={status}
        selectedDates={selectedDates || []}
        setSelectedDates={setSelectedDates}
        planDate={planDate}
        matchingDates={plan?.matchingDates}
        handleAction={handleAction}
        handleClose={handleClose}
      />

      <Button
        sx={{
          color: "var(--text)",
          backgroundColor: "var(--primary)",
          "& :hover": {
            borderColor: "var(--primary)",
          },
        }}
        onClick={() => {
          setOpen(true);
          setStatus("approve");
        }}
      >
        Approve
      </Button>
      <Button
        sx={{}}
        variant="outlined"
        onClick={() => {
          setOpen(true);
          setStatus("edit");
        }}
      >
        Send for Edit
      </Button>
    </div>
  );
};

export default PJPAction;
